import Vue from 'vue';

const success = (context, response) => {
  if (response.data.errors && response.data.errors.length > 0) {
    response.data.errors.map((error) => {
      toastr.error(error);
    });
  } else {
    toastr.success(response.data.msg);
  }
  context.closeOverridePanel();
  context.smallLoading = false;
  context.overrideToEdit = {};
  context.disabledCheckbox = false;
  context.enableMultipleModification = false;
  context.isUpdatedOverride = true;
};

const failed = (context, error) => {
  context.closePanelOverlay();
  context.smallLoading = false;
  context.showToasterError(error);
  context.overrideToEdit = {};
  context.disabledCheckbox = false;
  context.enableMultipleModification = false;
  context.isUpdatedOverride = true;
};

export default (context, data) => {

  delete data.rental;
  
  return Vue.$http.post('/update-rental-override', data)
    .then((response) => {
      if (response && response.status === 200) {
        success(context, response);
      }
    }).catch((error) => {
      failed(context, error);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/booking-com/updateOverrideStatus.js